export const namespaced = true;

// default routes for logged-in and non logged-in users
const DEFAULT_ROUTES = [];
DEFAULT_ROUTES[true] = "/catalog";
DEFAULT_ROUTES[false] = "/about";

export const state = {
  nextRoute: null
};

export const getters = {
  /*jshint unparam: true*/
  nextRoute(state, getters, rootState, rootGetters) {
    let route = state.nextRoute;
    if (!route) {
      route = DEFAULT_ROUTES[rootGetters["accounts/isLoggedIn"]];
    }
    return route;
  }
};

export const mutations = {
  SET_NEXT(state, nextRoute) {
    state.nextRoute = nextRoute;
  }
};

export const actions = {
  setNextRoute({ commit }, route) {
    commit("SET_NEXT", route);
  }
};
